import React from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import { map } from 'lodash';

import { SettingsDropdown } from 'components';
import { msgMapping } from './constants';
import useOddFormatSelect from './useOddFormatSelect';

import arrows from 'assets/svg/exchange-arrows.svg';
import './oddFormatSelect.scss';

const STUB = {
    glyph: arrows,
    width: 17,
    height: 17,
};

const OddFormatSelect: React.FC = () => {
    const { formatMessage } = useIntl();
    const {
        currOddFormat,
        title,
        filteredOddFormats,
        onMouseDown,
    } = useOddFormatSelect();

    return (
        <SettingsDropdown title={title} stub={STUB}>
            <div styleName="options">
                {map(filteredOddFormats, item => (
                    <div
                        key={item}
                        data-format={item}
                        styleName={cn('option', {
                            'is-selected': currOddFormat === item,
                        })}
                        onMouseDown={onMouseDown}
                    >
                        {formatMessage(msgMapping[item])}
                    </div>
                ))}
            </div>
        </SettingsDropdown>
    );
};

export default OddFormatSelect;
